import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { RIValidationContent } from './components/RIValidationContent';

export default function RIValidation() {
    return (
        <>
            <MainContent
                component={<RIValidationContent />}
                titulo='Admin. Inicio del Paciente'
                noBackground
                tableMaxWidth
            />
        </>
    );

};
